/**
 * @var {ApiMiddleware}
 */
import { find } from 'lodash'

let api = {}

/**
 * Set root path for api
 * @param {ApiMiddleware} middlewareObject
 */
export const setCompanyTemplateApiMiddleware = middlewareObject => {
    api = middlewareObject
}

export default () => ({
    state: {
        companyTemplates: [],
    },
    getters: {
        companyTemplates: state => state.companyTemplates,
        companyTemplateById: state => id => find(state.companyTemplates, t => t.id === id)
    },
    mutations: {
        setCompanyTemplates(state, companyTemplates) {
            state.companyTemplates = companyTemplates
        },
    },
    actions: {
        async companyTemplatesLoad({ commit }) {
            const setCompanyTemplates = await api.get('/companyTemplate')
            commit('setCompanyTemplates', setCompanyTemplates)
        },
        async companyTemplatesSave({ commit }, template) {
            await api.put(`/companyTemplate/${template.id}`, template)
        }
    },
})
